<div class="external-dropzone">
  <div class="dropzone-content">
    <div class="reasons-autocomplete">
      <div class="upload-section">
        <h2>
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 37 38">
            <g transform="translate(-246 -132)">
              <circle cx="18.5" cy="18.5" r="18.5" transform="translate(246 132)" fill="#ABCB0B"></circle>
              <text transform="translate(256 162)" fill="#FFF" font-size="30" font-family="Outfit" font-weight="700">
                <tspan x="0" y="0">2</tspan>
              </text>
            </g>
          </svg>
          <span class="analyse-header">
            analyse document(s)
          </span>
        </h2>

        <div class="toggle-pill-container">
          <div class="toggle-pill"  [ngClass]="{ 'active': nexusInputMode === 'dragdrop' }" (click)="nexusInputMode = 'dragdrop'">
            upload
          </div>
          <div class="toggle-pill" [ngClass]="{ 'active': nexusInputMode === 'freetext' }" (click)="nexusInputMode = 'freetext'">
            free text
          </div>
          <div class="toggle-pill" [ngClass]="{ 'active': nexusInputMode === 'link' }" (click)="nexusInputMode = 'link'">
            link
          </div>
        </div>
      </div>
    </div>
    
    <div *ngIf="nexusInputMode === 'dragdrop'" class="drag-drop-zone">
      <div class="dd-toolbar"></div>
        <div
          class="upload-wrap reset-row-parent"
          [class.disable-select]="isWaitingForSummary"
          [class.hide-file-actions]="!!summaryText"
        >
<div class="reset-row" *ngIf="showReset()">
 <span
  *ngIf="showUploadedBadge && uploadedDisplayName"
  class="uploaded-inline"
  [title]="uploadedDisplayName"
>
  <strong>uploaded:</strong>&nbsp;

  <a
    *ngIf="extensionPreviewUrl; else plainUploadedName"
    [href]="extensionPreviewUrl"
    target="_blank"
    rel="noopener"
  >
    view uploaded document
  </a>

  <ng-template #plainUploadedName>
    {{ uploadedDisplayName }}
  </ng-template>
</span>
  <button
    class="nexus-reset"
    type="button"
    (click)="clearUploadedFiles()"
    [disabled]="isResetting"
  >
    reset
  </button>
</div>

        <kendo-upload
          #upload="kendoUpload"
          [ngClass]="{ 'manual-mode': !autoUploadEnabled }"
          [autoUpload]="autoUploadEnabled"
          [saveUrl]="autoUploadEnabled ? uploadSaveUrl : 'noop'"
          [removeUrl]="uploadRemoveUrl"
          [batch]="false"
          [saveField]="'files'"
          [withCredentials]="true"
          [showFileList]="true"
          [restrictions]="{
            allowedExtensions: ['.pdf', '.jpg', '.jpeg', '.png'],
            maxFileSize: 30 * 1024 * 1024
          }"
          [accept]="'.pdf,.jpg,.jpeg,.png'"
          [requestHeaders]="requestHeaders"
          [files]="persistedFiles"
          [messages]="{
            invalidMaxFileSize: 'file is too large. maximum size is 30 MB.',
            invalidFileExtension: 'only PDF or image files are allowed.'
          }"
          (select)="onSelect($event)"
          (remove)="onRemove($event)"
          (upload)="autoUploadEnabled && uploadEventHandler($event)"
          (complete)="autoUploadEnabled && onComplete()"
          (success)="autoUploadEnabled && onUploadSuccess($event)"
          (error)="autoUploadEnabled && onUploadError($event)">
        </kendo-upload>
        
        <div class="upload-message locked-pdf-message" *ngIf="lockedPdfError">
          {{ lockedPdfError }}
        </div>

        <div class="k-upload-actions custom-actions" *ngIf="!autoUploadEnabled">
          <button
            type="button"
            class="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
            (click)="uploadAll()"
            [disabled]="!canUpload">
            upload
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="nexusInputMode === 'freetext'" class="free-text-zone">
      <div class="upload-wrap reset-row-parent">
        <div class="reset-row" *ngIf="showReset()">
          <button
            class="nexus-reset"
            type="button"
            (click)="clearUploadedFiles()"
            [disabled]="isResetting">
            reset
          </button>
        </div>

        <textarea
          placeholder="enter/paste challenge text..."
          [(ngModel)]="freeTextInput"
          (ngModelChange)="persistFreeText($event)"
          [disabled]="isSubmitting"
          rows="5"
          class="free-textarea"
          (input)="autoResize(textareaRef)"
          #textareaRef>
        </textarea>

        <button
          class="submit-button"
          (click)="handleTextSubmit(textareaRef)"
          [disabled]="isSubmitting || !freeTextInput.trim()">
          process
        </button>
      </div>
    </div>

    <div *ngIf="nexusInputMode === 'link'" class="link-input-zone">
      <div class="upload-wrap reset-row-parent">
        <div class="reset-row" *ngIf="showReset()">
          <button
            class="nexus-reset"
            type="button"
            (click)="clearUploadedFiles()"
            [disabled]="isResetting">
            reset
          </button>
        </div>

        <input
          id="linkInput"
          type="text"
          placeholder="paste link to pdf file..."
          [(ngModel)]="linkInput"
          (ngModelChange)="persistLink($event)"
          [disabled]="isSubmitting"
          class="link-input" />

        <button
          (click)="handleLinkSubmit()"
          [disabled]="isSubmitting || !linkInput"
          class="submit-button">
          process
        </button>
      </div>
    </div>

    <div *ngIf="isWaitingForSummary && !summaryText" class="summary-loading">
      <div class="rm-spinner" [ngClass]="spinnerStyle"></div>

      <p class="wavy-text" style="margin-top:10px;">
        <span *ngFor="let ch of progressChars; let i = index"
               [style.animationDelay]="(i * 0.3) + 's'">
          {{ ch === ' ' ? '\u00A0' : ch }}
        </span>
      </p>
    </div>
    <div *ngIf="summaryText" class="summary-section" #summarySection>
      <h3 class="summaryHeader">summary</h3>
      <ul>
        <li *ngFor="let reason of splitSummaryReasons()">
          {{ reason }}
        </li>
      </ul>
    </div>
  </div>
</div>
